// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageModal_wrapper__3Edqe","close":"ImageModal_close__P+VYE","image":"ImageModal_image__Laird","buttons":"ImageModal_buttons__nRFcQ","button":"ImageModal_button__Kz+D5"};